import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/sellers/save`,
        endpointGetAllCities: `${endpointBackend}gci/cities/getall`,
        endpointGetAllRealState: `${endpointBackend}gci/real-state/getall`,
        endpointGetById: `${endpointBackend}gci/sellers/getById`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        urlGoBack: `/gci/sellers/list`,
        pathView: `/gci/sellers/view`
    }

    const labels = {
        labelTitleAdd: "Novo Corretor",
        labelTitleEdit: "Editar Corretor",
        labelTitleView: 'Visualizar Corretor'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.gci_real_state_id = null;
                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'gci_real_state_id',
                    type: 'select',
                    label: 'Imobiliária',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllRealState,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: values.gci_company_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'technical_manager',
                    type: 'checkbox',
                    label: 'Responsável Técnico',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'document_type',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [
                        { label: 'CPF', value: 'CPF' },
                        { label: 'CNPJ', value: 'CNPJ' },
                    ],
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.document = '';
                        const form = getForm(values);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 6
                },
                {
                    name: 'document',
                    type: values.document_type,
                    label: values.document_type,
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                values.document_type === 'CNPJ' ? {
                    name: 'estadual_registration',
                    type: 'text',
                    label: 'Inscrição Estadual',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'name',
                    type: 'text',
                    label: values.document_type === 'CPF' ? 'Nome' : 'Razão Social',
                    validations: {
                        required: true
                    },
                    columnSize: values.document_type === 'CNPJ' ? 4 : 6
                },
                values.document_type === 'CNPJ' ? {
                    name: 'fantasy_name',
                    type: 'text',
                    label: 'Nome Fantasia',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                } : {},
                {
                    name: 'creci',
                    type: 'text',
                    label: 'CRECI',
                    validations: {
                        required: true
                    },
                    columnSize: values.document_type === 'CNPJ' ? 4 : 6
                },
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Foto',
                    uploadPath: '/sellers/',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'login',
                    type: 'text',
                    label: 'Login',
                    validations: {
                        required: true,
                        login: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password',
                    type: 'password',
                    label: 'Senha',
                    validations: {
                        password: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password_confirm',
                    type: 'password',
                    label: 'Repetir senha',
                    validations: {
                        password_confirm: true
                    },
                    columnSize: 12
                },
                {
                    name: 'phones',
                    type: 'multiinput',
                    label: 'Contatos',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Tipo',
                            type: 'select',
                            options: [{
                                label: "Tel. Institucional",
                                value: "TELINSTITUCIONAL"
                            },
                            {
                                label: "Tel. Fixo",
                                value: "TELFIXO"
                            },
                            {
                                label: "Recado",
                                value: "RECADO"
                            },
                            {
                                label: "Comercial",
                                value: "COMERCIAL"
                            },
                            {
                                label: "Residencial",
                                value: "RESIDENCIAL"
                            },
                            {
                                label: "Celular",
                                value: "CELULAR"
                            }],
                            name: 'type',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'Telefone',
                            type: 'phone',
                            name: 'phone',
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'emails',
                    type: 'multiinput',
                    label: 'Emails',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Tipo',
                            type: 'select',
                            options: [{
                                label: "Institucional",
                                value: "INSTITUCIONAL"
                            },
                            {
                                label: "Pessoal",
                                value: "PESSOAL"
                            },
                            {
                                label: "Comercial",
                                value: "COMERCIAL"
                            }],
                            name: 'type',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'Email',
                            type: 'email',
                            name: 'email',
                            maxLength: 100,
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCities,
                        label: 'city_name',
                        value: 'city_id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    label: 'Tipo de Endereço',
                    type: 'select',
                    options: [
                        {
                            label: "Comercial",
                            value: "COMERCIAL"
                        },
                        {
                            label: "Residencial",
                            value: "RESIDENCIAL"
                        }
                    ],
                    name: 'type_address',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                password: (value, options, key, attributes) => {
                    if (value && value.length < 8 && value.length > 0) {
                        return '^A senha deve ter no minímo 8 caracteres';
                    } else {
                        return '';
                    }
                },
                password_confirm: (value, options, key, attributes) => {
                    if (value !== attributes.password_confirm) {
                        return '^O campo repetir senha deve ter igual ao campo senha';
                    } else {
                        return '';
                    }
                },
                login: async (value, options, key, attributes) => {
                    const checkLogin = async (value) => {
                        const post = {
                            login: value
                        };

                        if (id) {
                            const post_manager = {
                                id
                            };

                            const manager = await Fetch.post(config.endpoints.backend + 'gci/sellers/getById', post_manager);
                            post.user_id = manager.core_user_id;
                        }

                        if (value && value.trim().length > 2) {
                            let response = await Fetch.post(config.endpoints.backend + 'core/users/getbylogin', post);
                            if (response.id) {
                                return '^O login já está sendo utilizado por outro usuário';
                            }
                        }

                        return "";
                    }
                    return checkLogin(value);
                }
            },
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            values.document_type = values.document_type || 'CPF';

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
